module.exports = __webpack_public_path__ + "img/en.e51718ef.svg";